<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar-menu></sidebar-menu>
    <div class="page-wrapper">
      <div class="content">
        <pageheader :title="title" :title1="title1" />

        <!-- /add -->
        <div class="card">
          <div class="card-body">
            <!-- <Form @submit="update" :validation-schema="schema" v-slot="{ errors }"> -->
            <div class="row">
              <div class="d-flex align-items-center">

                <div class="search-set " style="margin-top: 10px !important; margin-bottom: 0px !important;">
                  
                  <div class="search-input">
                      <a class="btn btn-searchset"><img src="@/assets/img/icons/search-white.svg"
                              alt="img" /></a>
                      <div id="DataTables_Table_0_filter" class="dataTables_filter">
                          <label>
                              <input type="search" class="form-control form-control-sm"
                                  placeholder="Search..." aria-controls="DataTables_Table_0"
                                  v-model="query" />
                          </label>
                      </div>
                  </div>
  
  
                    
                </div>
                <div class="wordset">
                    <ul>
                        <!-- <li class="" >
                            <router-link class=" d-flex flex-column justify-content-between  align-items-center " to="importschedule" style="margin-top: 15px !important; margin-bottom: 0px !important;"><vue-feather
                                    type="upload" class="text-success"></vue-feather> <span class="text-black">Import</span></router-link>
                        </li> -->

                        <li>
                            <div class="form-group" style="margin-top: 10px !important; margin-bottom: 0px !important;">
                                <div class="input-groupicon" style="z-index: 100;">
                                    <!-- <datepicker v-model="periode" class="picker" :editable="true"
                                        :clearable="false" @update:modelValue="index" /> -->
                                    <!-- <a class="addonset">
                                        <i class='bx bx-calendar'></i>
                                    </a> -->
                                    <DatePicker 
                                        v-model:value="periode" 
                                        type="date"
                                        range
                                        format="YYYY-MM-DD"
                                        value-type="format"
                                        :clearable="true"
                                        class="picker"
                                        
                                        style="width: 268px !important;" 
                                    />

                                    <!-- @change="onDateChange" pindahin ke datepicker klo harus langsung triggered ke index methods -->
                                </div>
                            </div>
                        </li>

                        <li class="d-flex align-items-center gap-3">
                            <a data-bs-toggle="tooltip" data-bs-placement="top" title="Generate"
                                @click="generateData"
                                class="d-flex flex-column justify-content-center  align-items-center mt-2 btn btn-primary p-1">
                                <i class='bx bx-refresh' style="font-size: 25px;"></i> 
                                <!-- <span
                                    class="text-black">
                                    generate
                                </span> -->
                            </a>

                            <a data-bs-toggle="tooltip" data-bs-placement="top" title="excel"
                                @click="insert"
                                class="d-flex flex-column justify-content-center  align-items-center btn btn-primary p-1 mt-2"><img
                                    src="../../../assets/img/Import_fill.png" alt="img" width="25" /> 
                                    <!-- <span
                                    class="text-black">
                                    excel
                                </span> -->
                            </a>

                        </li>
  
                        
                        
  
                    </ul>
                </div>

              </div>
              
              <div class="table-responsive mt-3">
                  <a-table :columns="columns" :data-source="filteredData" :loading="loading">
                      <template #bodyCell="{ column, record }">
                          <template v-if="column.key === 'no'">
                              <div class="productimgname">
                                  {{ record.no }}
                              </div>
                          </template>
                          <!-- <template v-if="column.key === 'deskripsi'">
                              <div class="productimgname">
                                  {{ shortenDescription(record.deskripsi) }}
                              </div>
  
  
                          </template> -->

                          <!-- <template v-if="column.key === 'hadir'" >
                            <p class="text-end">

                              {{ Math.floor(record.hadir) }}
                            </p>
                              
  
  
                          </template> -->
                          

  
                          
  
                          <!-- <template v-else-if="column.key === 'action'">
                              
                              <router-link class="me-3" to="editother_deduction" @click="edit(record);">
                                  <img src="@/assets/img/icons/edit.svg" alt="img" />
                              </router-link>
                              <a class="confirm-text" href="javascript:void(0);"
                                  @click="terminate(record.id, record.nama_departemen); showModal('terminate');">
                                  <img src="@/assets/img/icons/delete.svg" alt="img" />
                              </a>
                          </template> -->
                      </template>
                  </a-table>
              </div>
            </div>

          </div>
        </div>
        <!-- /add -->
      </div>
    </div>
  </div>
</template>
<script>
import Cookies from "js-cookie";
import axios from "axios";
import { base_url, AlertPopup2, AlertBottom, appendForm, timeout, selectedBranch, goPage } from "@/assets/js/function";
import { watch } from "vue";

import DatePicker from 'vue-datepicker-next'
import 'vue-datepicker-next/index.css'


export default {
  // components: {
  //   Form,
  //   Field,
  // },

  components: {
        DatePicker
        
  },

  name: "editemployee",
  data() {
    return {
      filter: true,
      title: "HR Summary Report",
      title1: "generate summary report",
      config: "",
      api: "",

      loading: false,
      // periode: new Date(),
      periode: [],

      data: [],
      columns: [
              {
                  title: "No",
                  dataIndex: "no",
                  key: "no",
                  sorter: {
                      compare: (a, b) => {
                          a = a.no.toLowerCase();
                          b = b.no.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },
              
              
              {
                  title: "Employee ID",
                  dataIndex: "employee_id",
                  key: "employee_id",
                  sorter: {
                      compare: (a, b) => {
                          a = a.employee_id.toLowerCase();
                          b = b.employee_id.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },
              {
                  title: "Employee",
                  dataIndex: "nama_karyawan",
                  key: "nama_karyawan",
                  sorter: {
                      compare: (a, b) => {
                          a = a.nama_karyawan.toLowerCase();
                          b = b.nama_karyawan.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },

              {
                  title: "Presence",
                  dataIndex: "hadir",
                  key: "hadir",
                  
                  sorter: {
                      compare: (a, b) => {
                          a = a.hadir.toLowerCase();
                          b = b.hadir.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },
              {
                  title: "Late",
                  dataIndex: "terlambat",
                  key: "terlambat",
                  
                  sorter: {
                      compare: (a, b) => {
                          a = a.terlambat.toLowerCase().localeCompare(a.terlambat.toLowerCase());
                          b = b.terlambat.toLowerCase().localeCompare(b.terlambat.toLowerCase());
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },
              {
                  title: "Leave",
                  dataIndex: "izin",
                  key: "izin",
                  // align: "right",
                  sorter: {
                      compare: (a, b) => {
                          a = a.izin.toLowerCase();
                          b = b.izin.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },
              {
                  title: "Annual Leave",
                  dataIndex: "cuti",
                  key: "cuti",
                  // align: "right",
                  sorter: {
                      compare: (a, b) => {
                          a = a.cuti.toLowerCase();
                          b = b.cuti.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },
              {
                  title: "Absent",
                  dataIndex: "absen",
                  key: "absen",
                  // align: "right",
                  sorter: {
                      compare: (a, b) => {
                          a = a.absen.toLowerCase();
                          b = b.absen.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },
              {
                  title: "National Holiday",
                  dataIndex: "libur",
                  key: "libur",
                  // align: "right",
                  sorter: {
                      compare: (a, b) => {
                          a = a.libur.toLowerCase();
                          b = b.libur.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },
              {
                  title: "Day Off",
                  dataIndex: "off",
                  key: "off",
                  // align: "right",
                  sorter: {
                      compare: (a, b) => {
                          a = a.off.toLowerCase();
                          b = b.off.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },
              {
                  title: "Total",
                  dataIndex: "total",
                  key: "total",
                  // align: "right",
                  sorter: {
                      compare: (a, b) => {
                          a = a.total.toLowerCase();
                          b = b.total.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },
             

              // {
              //     title: "Action",
              //     key: "action",
              //     sorter: false,
              // },
      ],

      //filter
      query: "",

      //data
      currentData: {
      },
      startDate: new Date,
      endDate: new Date,

      formatFilter: "EXCEL",
      FormatList: ["PDF", "EXCEL"],
    };
  },

  created() {
    const token = Cookies.get("token_refresh");
    this.config = {
      headers: {
        Authorization: `Bearer ` + token,
      },
      timeout: 30000,
    }
    
    const branch = parseInt(localStorage.getItem("selectedBranch")) || 0;

    //Update local and shared state
    this.filter = branch;
    selectedBranch.value = branch;

    localStorage.setItem('actionState', 'view')

    // Set default date range (1st to last day of current month)
    const storedStart = localStorage.getItem("startCutOff");
    const storedEnd = localStorage.getItem("EndCutOff");

    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth(); // zero-based
    
    // const start = new Date(year, month - 1, storedStart ? parseInt(storedStart) : 1);
    const startDay = storedStart ? parseInt(storedStart) : 1;
    const endDay = storedEnd ? parseInt(storedEnd) : 0;

    const start = new Date(year, month, startDay);

    let end;
    if (startDay === 1) {
        // If start is 1st → end is last day of same month
        end = new Date(year, month + 1, 0);
    } else {
        if (endDay > 0) {
            // If endDay <= startDay, it should be in the *next* month
            if (endDay <= startDay) {
            end = new Date(year, month + 1, endDay);
            } else {
            end = new Date(year, month, endDay);
            }
        } else {
            // fallback if storedEnd missing
            end = new Date(year, month + 1, 0);
        }
    }


    this.periode = [
      this.formatDateLocal(start),
      this.formatDateLocal(end),
    ];

     // Auto-fill from localStorage if exists
    const storedNama = localStorage.getItem('namaEmployee');
    if (storedNama) {
      this.query = storedNama;
    }

  },

  mounted() {
        watch(selectedBranch, () => {
            this.index()
        }, { immediate: true })
    },

  computed: {
    filteredData() {
      // If no query entered, return all data
      if (this.query === '') {
        return this.data;
      }

      const lowerCaseQuery =  (this.query || '').toLowerCase();

      return this.data.filter(item => {
        return (
          (item.nama_karyawan || '').toLowerCase().includes(lowerCaseQuery) ||
          (item.hadir || '').toLowerCase().includes(lowerCaseQuery) ||
          (item.terlambat|| '').toLowerCase().includes(lowerCaseQuery) ||
          (item.izin|| '').toLowerCase().includes(lowerCaseQuery) ||
          (item.cuti|| '').toLowerCase().includes(lowerCaseQuery) ||
          (item.absen|| '').toLowerCase().includes(lowerCaseQuery) ||
          (item.libur|| '').toLowerCase().includes(lowerCaseQuery) ||
          (item.off|| '').toLowerCase().includes(lowerCaseQuery) ||
          (item.total || '').toLowerCase().includes(lowerCaseQuery)
        );
      });
    }
  },



  methods: {


    formatDateLocal(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is 0-based
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },


    async insert() {
        
        let formData = new FormData();
        appendForm(formData)

        if (this.periode && this.periode.length === 2) {
            const [startDate, endDate] = this.periode;
            formData.append("dfrom",  startDate);  // end date
            formData.append("dto", endDate);  // start date
        }

        for (let [key, value] of formData.entries()) {
            console.log(key, value);
        }
        // CloseLoading(); return;

        const api = base_url + '/v3/reports/summary_excel';
        const res = await axios.post(api, formData, { timeout });
        const data = res.data;
        // console.log('ini data overtime:', data)

        if(data.status){
            window.open(data.data.file_report, "_blank");
            
        }else {
            AlertPopup2("error", "", data.message, true, 1500);
        }
            
        
    },

    onDateChange(value) {
        this.periode = value;
        this.index();
    },

    generateData() {
        this.index()
    },

    async index() {
           this.loading = true;

           try{

               let formData = new FormData();
               appendForm(formData)
   
               // Ensure periode has both start and end dates
               if (this.periode && this.periode.length === 2) {
                   const [startDate, endDate] = this.periode;
                   formData.append("dfrom",  startDate);  // end date
                   formData.append("dto", endDate);  // start date
               }
               
               for (let [key, value] of formData.entries()) {
                   console.log(key, value);
               }
               //return;
   
               const api = base_url + '/v3/reports/summary';
               const res = await axios.post(api, formData, { timeout });
               const data = res.data;
               const hrSummary = data.data.data_hr_summary;
               //    console.log('ini data overtime:', data)
               
               if(data.status){
                   this.data = [];
   
                   hrSummary.forEach((item, index) => {
                       let item_prepare = { ...item, no: (index + 1), };
                       this.data.push(item_prepare);
                   });
                   
               }else {
                   AlertPopup2("error", "", data.message, true, 1500);
               }
           } catch(err) {
                console.error(err);
                AlertPopup2("error", "", "Something went wrong.", true, 1500);
           } finally {
                this.loading = false;
            }

           
    },

  },

};
</script>

